import { Quote } from "lucide-react";
import ScrollReveal from "../ScrollReveal";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal className="mb-14 md:mb-20 max-w-2xl">
          <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
            / Testimonials
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight leading-[1]">
            Words from<br /><span className="text-white/40">founders.</span>
          </h2>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <ScrollReveal key={t.name} delay={i * 0.06}>
              <div
                data-testid={`testimonial-${i}`}
                className="bg-[#080808] border border-white/10 p-8 md:p-10 h-full flex flex-col hover:border-white/25 transition-colors"
              >
                <Quote size={22} className="text-white/30 mb-6" strokeWidth={1.3} />
                <p className="text-base md:text-lg text-white/80 leading-relaxed mb-6 font-light">
                  “{t.quote}”
                </p>
                <div className="mt-auto pt-6 border-t border-white/10">
                  <div className="font-display text-sm font-bold uppercase tracking-wider">
                    {t.name}
                  </div>
                  <div className="text-xs text-white/40 mt-1 tracking-wider">
                    {t.role}
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
